// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".nav-links[data-v-b1601ade]{font-size:1.75rem;font-weight:600;line-height:1.14285714}.locale.nuxt-link-active[data-v-b1601ade],.nav-links .nuxt-link-exact-active[data-v-b1601ade]{text-decoration-line:underline;text-underline-offset:5px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
